import React from "react"
import "./Tour.css"

import { getShows } from "../database/dataAccess.js";
import { SectionHeader } from "../SectionHeader"
import { SOCIAL_LINKS } from "../links"

const HOME_PAGE_PAST_SHOW_LIMIT = 4

const instagram = SOCIAL_LINKS.find(link => link.name === "Instagram")

// show dates are stored as "MM/DD/YYYY"
const parseShowDate = (show) => {
    const [month, day, year] = show.date.split('/').map(Number)
    return new Date(year, month - 1, day)
}

const startOfToday = new Date()
startOfToday.setHours(0, 0, 0, 0)

const shows = getShows()
    .map(show => ({ ...show, parsedDate: parseShowDate(show) }))
    .sort((show1, show2) => show1.parsedDate - show2.parsedDate)

const upcomingShows = shows.filter(show => show.parsedDate >= startOfToday)

const pastShows = shows.filter(show => show.parsedDate < startOfToday).reverse()

const ShowRow = ({ show, past }) => (
    <li className="lf-show">
        <div className="lf-show__date">
            <strong>{String(show.parsedDate.getDate()).padStart(2, "0")}</strong>
            <span>
                {show.parsedDate.toLocaleString('en-US', { month: 'short' }).toUpperCase()} {show.parsedDate.getFullYear()}
            </span>
        </div>
        <div className="lf-show__venue">
            {show.locationName}
            {show.eventName && <span className="lf-show__event">{show.eventName}</span>}
        </div>
        <div className="lf-show__city">{show.locationCityState}</div>
        <div className="lf-show__action">
            {past
                ? <span className="lf-show__tag">PLAYED</span>
                : <>
                    {show.eventRsvp && <a className="lf-btn" target="_blank" rel="noreferrer" href={show.eventRsvp}>RSVP</a>}
                    {show.eventTickets
                        ? <a className="lf-btn lf-btn--primary" target="_blank" rel="noreferrer" href={show.eventTickets}>TICKETS</a>
                        : <span className="lf-show__tag">TICKETS AT DOOR</span>}
                </>}
        </div>
    </li>
)

export const Tour = ({ homePage }) => {
    const visiblePastShows = homePage ? pastShows.slice(0, HOME_PAGE_PAST_SHOW_LIMIT) : pastShows

    return (
        <section className="lf-section lf-tour" id="tour">
            <div className="lf-tour__bgword">LIVE</div>
            <div className="lf-wrap lf-tour__inner">
                <SectionHeader eyebrow="On the road" title="Tour" />

                {upcomingShows.length > 0
                    ? <ul className="lf-shows lf-shows--upcoming">
                        {upcomingShows.map(show => <ShowRow key={show.id} show={show} />)}
                    </ul>
                    : <div className="lf-tour__empty">
                        <div>
                            <h3>No dates announced — yet.</h3>
                            <p>New shows get announced on Instagram first.</p>
                        </div>
                        <a className="lf-btn lf-btn--primary" target="_blank" rel="noreferrer" href={instagram.href}>
                            <i className={instagram.icon}></i> Follow for updates
                        </a>
                    </div>}

                {visiblePastShows.length > 0 && <>
                    <div className="lf-tour__label">{"// PAST SHOWS"}</div>
                    <ul className="lf-shows">
                        {visiblePastShows.map(show => <ShowRow key={show.id} show={show} past />)}
                    </ul>
                </>}
            </div>
        </section>
    )
}
